export default __webpack_public_path__ + "static/media/baptiste.f005bca8.jpg";